module.exports = __webpack_public_path__ + "static/media/Google_playstore_01.ac5fad1a.svg";